'use strict';

var luxon = require('luxon');
var y = require('yup');
var dateString = require('../dateString/dateString.js');

function _interopNamespaceCompat(e) {
  if (e && typeof e === 'object' && 'default' in e) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'dateOfBirth';
const DATE_OF_BIRTH_ERROR = 'invalidDateOfBirth';
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    const format = options?.format ?? dateString.DEFAULT_FORMAT;
    return this.dateString({
        format: format,
        error: options?.formatError
    }).test({
        name,
        message: {
            key: options?.error ?? DATE_OF_BIRTH_ERROR
        },
        test: (value)=>{
            /**
             * User must be at least 18, compute max allowable birth date.
             */ if (value) {
                const input = luxon.DateTime.fromFormat(value, format).startOf('day');
                return input >= luxon.DateTime.now().startOf('day').minus({
                    years: 100
                }) && input <= luxon.DateTime.now().startOf('day').minus({
                    years: 18
                });
            }
            return true;
        }
    });
});

exports.DATE_OF_BIRTH_ERROR = DATE_OF_BIRTH_ERROR;
//# sourceMappingURL=dateOfBirth.js.map
